import React, { useEffect } from 'react'
import { useCookies } from 'react-cookie'

import { Landing } from 'ui/acro'
import { Alert, Button, Header, CTA, Headline } from 'ui/chandra'

import { useSurveyContext } from '../../_store'
import { callAll } from 'utils'
import { survey_skipped_event, survey_started_event } from 'gtm/pushEvents'
import styled from 'styled-components'

const Onboarding = (props) => {
  const { state, actions } = useSurveyContext()
  const [cookies, setCookie] = useCookies(['onboarding_survey_seen'])
  const cookiePath = { path: '/' }
  const mweUserEnrolled = cookies.mwe_new_user_enrolled === 'true'
  const welcomeScreen = '/subscribe/welcome'
  const subscribe = '/subscribe'

  // Set cookies on load
  useEffect(() => {
    setCookie('onboarding_survey_seen', true, cookiePath)
  }, [])

  const ButtonTakeSurvey = styled(Button)`
    width: 100%;
    height: 100%;
    margin-right: 16px;
    margin-bottom: 0px;
    flex-grow: 1;

    @media all and (max-width: 1024px) {
      color: white;
      background: black;
      width: 100%;
      margin-right: 16px;
    }

    @media all and (max-width: 1023px) {
      color: black;
      background: white;
      border-radius: 0px;
    }
  `

  const ButtonSkip = styled(Button)`
    width: 100%;
    height: 100%;
    margin-bottom: 0px;
    flex-grow: 1;
    border: 1px solid black;

    @media all and (max-width: 1024px) {
      border: 1px solid white;
      margin-top: 15px;
      border-radius: 0px;
    }
  `

  const HeaderContent = styled(Header)(() => ({
    margin: '25px 0 25px 0'
  }))

  const FlexButtonContainer = styled('div')`
    display: flex;
    flex-direction: row;

    @media all and (max-width: 1024px) {
      flex-direction: column;
    }
  `

  const CTAContainer = styled(CTA)`
    color: #000000;
    @media all and (max-width: 1024px) {
      color: #ffffff;
    }
  `

  return (
    <Landing
      image='https://alomoves.s3.amazonaws.com/manual_uploads/shared/surveys/onboarding/landing/start-survey.jpg'
      border={true}
    >
      <CTAContainer>Welcome!</CTAContainer>

      <Headline>LET’S PERSONALIZE YOUR PRACTICE</Headline>

      <HeaderContent>
        {/* Take this survey to receive <strong>your personalized</strong> class
        recommendations. */}
        Help us find what moves you by completing this quick questionnaire.
      </HeaderContent>

      {state.error && <Alert type='error' message={state.error} />}

      <FlexButtonContainer>
        <ButtonTakeSurvey
          onClick={callAll(actions.start, survey_started_event)}
          variant={'solid'}
          id='survey_start'
          processing={state.loading}
          aria-label='Take Survey'
        >
          LET’S MOVE
        </ButtonTakeSurvey>

        <ButtonSkip
          type='link'
          onClick={survey_skipped_event}
          href={mweUserEnrolled ? welcomeScreen : subscribe}
          variant='ghost'
          id='survey_skip'
          aria-label='Skip For Now'
        >
          Skip For Now
        </ButtonSkip>
      </FlexButtonContainer>
    </Landing>
  )
}

export default Onboarding
